/**
 * All the events related to CANVAS to be logged in amplitude
 * ----------------------------------------------------------
 * rule: export all the events with it's name & origin
 * name: actionObject_actionVerb
 * origin: from which page it is generated, if '' then set it from the URL params
 */

export const editorPageEvents = [
	"preview_clicked",
	"widget_duplicated",
	"addWidget_clicked",
	"dashboard_deleted",
	"globalFilter_deleted",
	"widget_deleted",
	"dashboard_saved",
	"dashboard_renamed",
	"editWidget_clicked",
	"editFilter_clicked",
	"globalFilter_added",
	"theme_updated"
];

export const previewPageEvents = ["dashboard_opened", "dashboard_scrolled", "editor_clicked"];

export const userManagementPageEvents = [
	"addUserButton_clicked",
	"user_removed",
	"user_accessRemoved",
	"user_accessProvided"
];

export const widgetListingPageEvents = ["widget_selected"];

export const configureWidgetPageEvents = ["backButton_clicked", "widget_saved"];

export const configureFiltersPageEvents = ["filter_saved"];

export const themeSettingsPageEvents = [
	"resetDefault_clicked",
	"saveChanges_clicked",
	"backButton_clicked",
	"themeColor_changed"
];

// --- Events that can originate from any page ---
export const anyPageEvents = [
	"logout",
	"queryBuilder_opened",
	"appDrawer_opened",
	"appDrawer_closed",
	"app_clicked",
	"themeSettings_opened",
	"userManagement_opened",
	"manualMode_toggled",
	"reportScheduler_opened"
];

export const previewNPublishPageEvents = ["preview_clicked", "backButton_clicked", "dashboard_published"];

export const reportSchedulerPageEvents = [
	"addSchedule_clicked",
	"editSchedule_clicked",
	"deleteSchedule_clicked",
	"schedule_saved",
	"schedule_closed",
	"reportSchedulerBackButton_clicked"
];

export const dasdboardDownloadEvents = ["dashboardDownload_clicked", "dashboardDownload_selected"];

export const widgetLoadTimeEvents = ["widget_loadTime", "filter_loadTime"];

export const publicDashboardEvents = [
	"publicLink_clicked",
	"publicLink_generated",
	"publicLink_copied",
	"publicLinkModal_opened",
	"publicLinkModal_failed"
];
